<template>
  <div class="row">
    <Loader v-if="!resourceLoaded" />
    <div class="col-12" v-if="resourceLoaded">
      <div class="panel-content-inner">
        <div class="row">
          <table
            id="dashboard-table"
            class="superconciergerie-table text-center table table-responsive"
          >
            <thead>
              <tr>
                <th>{{ $t("superconcierge.dashboard.rental_owner") }}</th>
                <th>{{ $t("superconcierge.dashboard.rental_name") }}</th>
                <th>{{ $t("superconcierge.dashboard.date") }}</th>
                <th>{{ $t("superconcierge.dashboard.arrivals") }}</th>
                <th>{{ $t("superconcierge.dashboard.departures") }}</th>
                <th style="font-weight: bold">{{ $t("superconcierge.dashboard.base_calculation") }}</th>
                <th style="font-weight: bold">{{ $t("superconcierge.dashboard.total_commission") }}</th>
                <th style="font-weight: bold">{{ $t("superconcierge.dashboard.total_cleaning") }}</th>
                <th style="font-weight: bold">{{ $t("superconcierge.dashboard.total_linen") }}</th>
                <th style="font-weight: bold">{{ $t("superconcierge.dashboard.total_checkin") }}</th>
                <th style="font-weight: bold">{{ $t("superconcierge.dashboard.total_fees") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rental in filteredMappedRentals" :key="rental.rental.id">
                <td>
                  <div>{{ rental.rental.owner.name }}</div>
                </td>
                <td>
                  <div>
                    <a
                      class="m-b-10 product-price action-title"
                      :href="'#/rentals/' + rental.rental.id"
                      target="_blank"
                      >{{ rental.name }}</a
                    >
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      capitalize(moment(rental.year + "-" + rental.month).locale("fr").format("MMMM YYYY"))
                    }}
                  </div>
                </td>
                <td>
                  <div>{{ rental.arrivals }}</div>
                </td>
                <td>
                  <div>{{ rental.departures }}</div>
                </td>
                <td>
                  <div style="font-weight: 600">{{ rental.total_base_calculation.toFixed(2) }}{{ rental.currency }}</div>
                </td>
                <td>
                  <div style="font-weight: 600">{{ rental.total_commissions.toFixed(2) }}{{ rental.currency }}</div>
                </td>
                <td>
                  <div
                    :id="'rental-' + rental.rental.id + '-total_cleaning'"
                    style="font-weight: 600"
                    @click.prevent="showInputField(rental.rental, 'total_cleaning', 'rental-', updateRental, this)"
                  >
                    {{ rental.total_cleaning.toFixed(2) }}{{ rental.currency }}
                  </div>
                </td>
                <td>
                  <div
                    :id="'rental-' + rental.rental.id + '-total_linen'"
                    style="font-weight: 600"
                    @click.prevent="showInputField(rental.rental, 'total_linen', 'rental-', updateRental, this)"
                  >{{ rental.total_linen.toFixed(2) }}{{ rental.currency }}</div>
                </td>
                <td>
                  <div
                    :id="'rental-' + rental.rental.id + '-total_checkin'"
                    style="font-weight: 600"
                    @click.prevent="showInputField(rental.rental, 'total_checkin', 'rental-', updateRental, this)"
                  >{{ rental.total_checkin.toFixed(2) }}{{ rental.currency }}</div>
                </td>
                <td>
                  <div style="font-weight: 600">{{ rental.total_fees.toFixed(2) }}{{ rental.currency }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import superconciergerie from "../../../services/superconciergerie";
import moment from "moment";

export default {
  data() {
    return {
      resourceLoaded: false,
      mappedRentals: [],
      filteredMappedRentals: [],
      rentals: [],
      filteredRentals: [],
      filteredRentalIds: [],
      owners: [],
      filteredOwners: [],
      filteredOwnerIds: [],
    };
  },
  methods: {
    moment,
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async updateRental(rental, field, vm) {
      const rentalId = rental.id;
      if (!document.getElementById("input-" + rentalId + "-" + field)) {
        return;
      }
      let value = document.getElementById(
        "input-" + rentalId + "-" + field
      ).value;

      if (rental[field] != value) {
        rental[field] = parseFloat(value);
        await superconciergerie.updateRental(this, rental);
      }

      document.getElementById("rental-" + rentalId + "-" + field).innerHTML =
        parseFloat(value).toFixed(2) + "€";
      // document.getElementById("input-"+rentalId+"-"+field).remove();
      vm.updateField = null;
    },
    async loadResource() {
      if (this.activeTab === "dashboard" && !this.resourceLoaded) {
        await superconciergerie.getMappedRentals(this);

        this.$root.$emit('dashboard_rentals_setFilterElems', this.filteredRentals);
        this.$root.$emit('dashboard_rentals_setFilterFallback', (ids) => this.filterData(ids, this, "rentals"));

        this.$root.$emit('dashboard_owners_setFilterElems', this.filteredOwners);
        this.$root.$emit('dashboard_owners_setFilterFallback',(ids) => this.filterData(ids, this, "owners"));

        this.$root.$emit('dashboard_dates_setDateFilterFallback',(date) => {
          this.resourceLoaded = false;
          superconciergerie.getMappedRentals(this, date).then(() => {
            this.resourceLoaded = true;

            this.filteredMappedRentals = this.mappedRentals.filter((rental) => {
              const rentalMatch = !this.filteredRentalIds.length || this.filteredRentalIds.includes(rental.rental.id);
              const ownerMatch = !this.filteredOwnerIds.length || (rental.rental.owner && this.filteredOwnerIds.includes(rental.rental.owner.id));

              return rentalMatch && ownerMatch;
            });
          });
        });

        this.resourceLoaded = true;
      }
    },
    filterData(filteredIds, context, target) {
      if(target === "rentals") {
        context.filteredRentalIds = filteredIds;
      } else {
        context.filteredOwnerIds = filteredIds;
      }

      context.filteredMappedRentals = this.mappedRentals.filter((rental) => {
        const rentalMatch = !context.filteredRentalIds.length || context.filteredRentalIds.includes(rental.rental.id);
        const ownerMatch = !context.filteredOwnerIds.length || (rental.rental.owner && context.filteredOwnerIds.includes(rental.rental.owner.id));

        return rentalMatch && ownerMatch;
      });
    },
  },
  props: ["activeTab", "showInputField"],
  async mounted() {
    await this.loadResource();
  },
  watch: {
    activeTab: async function (val) {
      await this.loadResource();
    },
    mappedRentals: async function (val) {
      // Get rentals
      const rentals = [];
      val.forEach((mR) => {
        if (!rentals.find((rental) => rental.id === mR.rental.id)) {
          rentals.push(mR.rental);
        }
      });
      this.rentals = rentals;
      this.filteredRentals = rentals;

      // Get owners
      this.owners = this.rentals.map(rental => rental.owner);
      this.owners = this.owners.filter(o => o != null);
      this.owners = this.owners.filter((owner, index, self) =>
          index === self.findIndex((t) => (
            t.id === owner.id
          ))
      );
      this.filteredOwners = this.owners;
    },
    // filteredRentals: async function (val) {
    //   if(val.length === 0) {
    //     this.filteredMappedRentals = this.mappedRentals;
    //     return;
    //   }
    //   this.filteredMappedRentals = this.mappedRentals.filter((mR) => {
    //     return val.find((rental) => rental.id === mR.rental.id);
    //   });
    // },
  },
  components: {
    Loader: require('../components/Loader.vue'),
  },
};
</script>



// WEBPACK FOOTER //
// DashboardTab.vue?218a43b1